import { Ziggy } from '@/modules/shared/helpers/facades/ziggy'
import { vsingleton } from '@niknevis/vue-modules'

@vsingleton()
export class WriterFinancialRoutes {
  deposits() {
    return Ziggy
      .route('writer.financial.deposits')
      .toString()
  }
}
